import { Trans } from 'react-i18next';
import VideoPoster from '../../assets/fc98bb574f45c6ac.jpg';
import Video from '../../assets/fc98bb574f45c6ac.mp4';
import { FrameLayout, useResponsivePadding, VerticalLayout } from '../../common/common-layout';
import { H10, SubH1 } from '../../common/common-text';
import i18n from '../../common/i18n/i18n';
import { pxToRem } from '../../common/utils/ConvertUtils';
import '../../css/bbpage.css';
import { useAnalytics } from '../../hooks/useAnalytics';
import { useDeviceType } from '../../hooks/useDeviceType';
import useVisualViewportHeight from '../../hooks/useVisualViewportHeight';

const SemiconductorFieldSection1 = () => {
  const { horizontal: padding, topSectionBottom: topSectionBottom } = useResponsivePadding(/*{ mode: 'fixed' }*/);
  const viewheight = useVisualViewportHeight();
  const { isMobile, isPad } = useDeviceType();
  const { trackVideoPlay } = useAnalytics();
  const isEng = ['en', 'en-mobile'].includes(i18n.language);
  const isChina = ['zh', 'zh-mobile'].includes(i18n.language);

  return (
    <VerticalLayout style={{
      background: '#335d9e',
      ...(isMobile && !isPad ? { height: viewheight } : {}),
    }}>
      <FrameLayout>
        <video
          src={Video}
          autoPlay
          muted
          loop
          playsInline
          poster={VideoPoster}
          onPlay={() => trackVideoPlay('반도체', 'semiconductor', 0)}
          style={{
            width: '100%',
            height: isMobile && !isPad ? '100%' : 'auto',
            display: 'block',
            objectFit: 'cover',
          }}
        />
        <SubH1 style={{
          color: 'white',
          position: 'absolute',
          bottom: (isMobile && !isPad) ? isEng ? '224px' : '141px' : `${topSectionBottom}px`,
          left: `${padding}px`,
          transform: isPad ? 'scale(0.80)' : 'scale(1)',
          transformOrigin: 'left bottom',
        }}>Semiconductor<br />Main Utility &<br />Process Piping</SubH1>
        <H10
          style={{
            width: isMobile && !isPad ? `calc(100% - ${padding * 2}px)` : pxToRem(510),
            color: 'white',
            position: 'absolute',
            bottom: isMobile && !isPad ? '0px' : `${topSectionBottom}px`,
            left: isMobile && !isPad ? `${padding}px` : undefined,
            right: isMobile && !isPad ? undefined : `${padding}px`,
            transform: isPad ? 'scale(0.85)' : 'scale(1)',
            transformOrigin: 'right bottom',
            ...(isMobile && !isPad
              && { height: isEng ? '212px' : `124px` }),
            ...isChina ? {wordBreak: 'break-word'} : {}
          }}
        >
          <Trans i18nKey='비비테크는 반도체 산업의 까다로운 기준을 만족시키는 초정밀 설비와 공정 기술을 보유하고 있습니다. 클린룸 설계부터 특수 배관, 자동제관까지 반도체 생산 환경에 최적화된 Total Solution을 제공합니다.'/>
        </H10>
      </FrameLayout>
    </VerticalLayout>
  );
};

export default SemiconductorFieldSection1;
